import uuid from 'uuid';

export const userService = {
  login,
  tokenLogin,
  verifyOTP,
  logout,
  register,
  update,
};

function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: username, password: password }),
  };

  return fetch(
    `${process.env.REACT_APP_BOTTL_API_ENDPOINT}/credentials/login/`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      localStorage.setItem('user', JSON.stringify(user.static_user));
      return user;
    });
}

function verifyOTP(id, otp) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, otp }),
  };

  return fetch(
    `${process.env.REACT_APP_BOTTL_API_ENDPOINT}/credentials/verify/otp/`,
    requestOptions
  )
    .then(handleResponse)
    .then((r) => {
      const base = JSON.parse(localStorage.getItem('user'));
      localStorage.setItem(
        'user',
        JSON.stringify({ ...base, require_otp: false })
      );
    });
}

function tokenLogin(token) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token: token }),
  };

  return fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/user/login/token/`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      localStorage.setItem('user', JSON.stringify(user));
      return user;
    });

  // localStorage.removeItem('user');
  // switch (process.env.DASHBOARD_ENV) {
  //   case 'bottl' :
  //     return fetch(`${process.env.REACT_APP_BOTTL_API_ENDPOINT}/credentials/login/token/`, requestOptions).then(handleResponse).then(user => {
  //       localStorage.setItem('user', JSON.stringify(user));
  //       return user;
  //     });
  //   break;
  //   case 'mw' :
  //     return fetch(`${process.env.REACT_APP_API_ENDPOINT}/user/login/token/`, requestOptions).then(handleResponse).then(user => {
  //       localStorage.setItem('user', JSON.stringify(user));
  //       return user;
  //     });
  //   break;
  // }
}

function logout() {
  localStorage.removeItem('user');
  localStorage.removeItem('newsfeed_ignored_blocks');
}

function register(user) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user),
  };

  return fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/users/register`,
    requestOptions
  ).then(handleResponse);
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(user),
  };

  return fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/users/${user.id}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (data.error) {
      if (data.error === 403) {
        logout();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
